import { ImageDetails } from './image-details.dto-response';
import { InventoryDtoResponse, InventoryDetailDtoResponse } from './inventory.dto-response';
import { LabourDtoResponse } from './labour.dto-response';
import { ProductDetail } from './product-card-detail.dto-response';

export class ProductDetailsDtoResponse {
  title: string;
  shortSKU: string;
  longSKU: string;
  pairNo: string;
  productType: string;
  productBrand: string;
  retailPrice: string;
  customerPrice: string;
  specialPrice: string;
  productImages: ImageDetails[];
  iconUrl: string;
  details: ProductDetail[];
  isNew: boolean;
  isPreLaunch: boolean;
  isSpecial: boolean;
  confirmedFitment: boolean;
  labours: LabourDtoResponse[];
  isDirectFit?: boolean;
  isAggressiveFitment?: boolean;
  isDrilled?: boolean;
  icons: ImageDetails[];
  inventory: InventoryDtoResponse;
  onHandDetails: InventoryDetailDtoResponse[];
  isBlem: boolean;
  isWinterWheel: boolean;
  warningNotes: string[];
	pcd: string;
  brandLogo: string;
  hasAlternateWarehouseMtl: boolean;
  hasAlternateWarehouseCal: boolean;
  hasAlternateWarehousePic: boolean;
  extensionCapRequired: boolean;
  extensionCapPrice?: number;
  description: string;
  landedCost: string;
  dealerCost: string;
  freeWMB?: boolean;
}
